import debounce from '../tools/debounce';

export default {
    namespaced: true,
    state: {
        activePopupIds: [],
        // presets: [],
    },
    mutations: {
        setPopup: (state, value) => state.activePopupIds.push(value),
        setEvent: (state, event) => state.event = event,
        setSinglePopup: (state, value) => {
            state.activePopupIds = [];
            state.activePopupIds.push(value);
        },
        deletePopup: (state, value) => {
            let findIndex = state.activePopupIds.indexOf(value);

            if (findIndex >= 0) {
                state.activePopupIds.splice(findIndex, 1);
            }
        },
        deleteAllPopup: (state) => {
            state.activePopupIds = [];
        },
    },
    actions: {
        openPopup: (ctx, id) => {
            ctx.commit('setPopup', id);
        },
        closePopup: (ctx, id) => {
            ctx.commit('deletePopup', id);
        },
        closeAllPopups: (ctx, e) => {
            if (e != ctx.state.event) {
                if(ctx.state.event && (!ctx.state.event.type || ctx.state.event.type != 'click')) {
                    ctx.commit('setEvent', null);
                } else {
                    ctx.commit('deleteAllPopup');
                    ctx.commit('setEvent', null);
                }
            }
        },
        openSinglePopup: (ctx, {id, e}) => {
            ctx.commit('setSinglePopup', id);
            ctx.commit('setEvent', e);
        },
    },
    getters: {
        getActivePopupId: state => id => state.activePopupIds.find(v => v === id) || null,
    },
};
